import React, { useContext, useEffect, useState } from 'react';
import './product-detail.scss';
import { getProductDeatil, getProductRelated, getSimilarProduct, getTranslate } from '@service/api';
import { ProductContext, SKUContext, CartContext, AccountContext } from '@components/Context';
// import { useClearSku } from '@lib/hooks';
import ProductDetailCarousel from '@modules/Product/ProductDetailCarousel';
import ColorPicker from '@modules/Product/ColorPicker';
import ProductInfo from '@modules/Product/ProductInfo';
import Promotion from '@modules/Product/Promotion';
import Features from '@modules/Product/Features';
import Specification from '@modules/Product/Specification';
import MerchantInfo from '@modules/Merchant/MerchantInfo';
import ProductAttributes from '@modules/Product/ProductAttributes';
import ProductDescription from '@modules/Product/ProductDescription';
import BrandInfo from '@modules/Brand/BrandInfo';
import Protect from '@modules/Product/Protect';
import SimilarProduct from '@modules/Product/SimilarProduct';
import OfficialWebsite from '@modules/Merchant/OfficialWebsite';
import ProductBottomBar from '@modules/Product/ProductBottomBar';
import ProductComment from '@modules/Comment/ProductComment';
import Coupon from '@modules/Product/Coupon';
import Loading from '@components/Loading';
import DownloadBar from '@components/DownloadBar';
import { setReopenFlag, paramstr, evokedAppType, getIdFromUrl } from '@lib/utils';
import { STAIC_ORIGIN, BXL_UTM_PARAMS } from '@lib/constants';
import SessionStorage from '@lib/session';
import SEO from './seo'

let pageShow = true;

function ProductDetail() {
    const productContext: any = useContext(ProductContext);
    const cartContext: any = useContext(CartContext);
    const accountContext: any = useContext(AccountContext);
    const skuContext: any = useContext(SKUContext);
    const productId = productContext?.product?.id || getIdFromUrl();
    const [loading, setLoading] = useState(false);
    const [translate, setTranslate] = useState();

    // const clearSku = useClearSku();
    const [downloadVisible, setDownloadVisible] = useState(false);

    useEffect(() => {
        setLoading(true);
        // clearSku();
        getProductDeatil(productId)
            .then((res: any) => {
                // let res = pageContext.productMsg
                productContext.updateProduct(res, () => {
                    setLoading(false);

                    if (pageShow) {
                        pageShow = false;
                    }
                });
                cartContext.updateActiveMerchant(res?.merchantId);
            })
            .catch((err: any) => {
                setLoading(false);
            })
        getProductRelated(productId)
            .then((res: any) => {
                productContext.updateMerchant(res.merchant || {});
                productContext.updateBrand(res.brand || {});
            })
            .catch((err: any) => {
            })
        getSimilarProduct(productId)
            .then((res: any) => {
                productContext.updateSimilar(res.products || []);
            })
            .catch((err: any) => {
            })
        getTranslate(productId)
            .then((res: any) => {
                setTranslate(res?.description);
            })
            .catch((err: any) => {
            });
    }, [productId]);

    useEffect(() => {
        setReopenFlag();
        document.title = '别样海外购';
    }, []);

    function downloadClose() {
        setDownloadVisible(false);
    }

    function downloadClick() {
        if (!window) {
            return
        }
        const utmParams = JSON.parse(SessionStorage.get(BXL_UTM_PARAMS) || '{}');
        const utmStr = paramstr(utmParams);
        const dLink = 'https://sensorsdata.bybieyang.com/r/Gz';
        const bieyang = encodeURIComponent(`bieyang:///pdp?productId=${productId}&${utmStr}&type=${evokedAppType()}`);
        const downloadLink = encodeURIComponent(dLink);
        window.location.href = `${STAIC_ORIGIN}/static/html/appEntry/index.html?bieyang=${bieyang}&download=${downloadLink}`;
    }

    const carouselImg = skuContext?.chosenSku?.images ? skuContext?.chosenSku?.images : productContext?.product?.images;    
    return (
        <div className='p-product-detail'>
            <SEO
                title={`${productContext?.product?.brand}_${productContext?.product?.nameCN || productContext?.product?.name} | 别样海外购 bieyangapp.com`}
                keywords={`${productContext?.product?.brand}_${productContext?.product?.nameCN || productContext?.product?.name}`}
                description={`${productContext?.product?.brand}_${productContext?.product?.nameCN || productContext?.product?.name} 别样海外购，欧美直邮 正品保障`}
            />
            <div className='carousel'>
                {(carouselImg && carouselImg.length) ?
                    <ProductDetailCarousel list={carouselImg} /> : null
                }
                <ColorPicker />
            </div>
            <ProductInfo />
            <Coupon />
            <Promotion />
            <Specification />
            <Features />
            <ProductComment />
            <MerchantInfo />
            <ProductAttributes />
            <ProductDescription />
            <OfficialWebsite description={translate || productContext?.product?.description} />
            <BrandInfo />
            <Protect />
            <SimilarProduct />
            <ProductBottomBar isMini={false} />
            {loading && <Loading />}
            {downloadVisible &&
                <DownloadBar
                    className='product-download-bar'
                    onClose={downloadClose}
                    onClick={downloadClick}
                />}
        </div>
    )
}

export default ProductDetail
